<div class="generalPage" aria-label="help-xbrlfeature" role="main">
  <div class="pr-22 content-container pb-0 print-all-content">
    <h1 class="generalHeader margin-0 content-blue bold itcHeavyFont pb-heading" role="heading">{{xbrl_heading}}</h1>
    <p class="answer font-16 content-blue width-100" (click)="openlinkbyId($event)" [innerHTML]="xbrl_desc"></p>
  </div>
</div>
